import { startBrowserLogs } from "@/platform/observability/datadog/logs"

startBrowserLogs()
